import { useDepartmentText } from 'model/DepartmentTerminology';
import { Select, SelectItem, SelectProps } from '@mantine/core';
import { EVIDENCE_FIELD_DEVICE_PROPERTIES } from 'components/forms/remote-source/config/device-properties';
import { useMemo } from 'react';

type DevicePropertySelectProps = Omit<SelectProps, 'data'>;

/**
 * Select for device properties.
 */
export default function DevicePropertySelect(props: DevicePropertySelectProps) {
  const departmentText = useDepartmentText();
  const properties: SelectItem[] = useMemo(
    () =>
      [
        { value: 'externalId', label: 'Externé ID', group: 'Základné info' },
        { value: 'deviceName', label: 'Názov zariadenia', group: 'Základné info' },
        { value: 'manufacturer', label: 'Výrobca', group: 'Základné info' },
        { value: 'manufactured', label: 'Rok výroby', group: 'Základné info' },
        { value: 'serialNumber', label: 'Výrobné číslo', group: 'Základné info' },
        { value: 'building', label: 'Budova', group: 'Umiestnenie' },
        { value: 'floor', label: 'Podlažie', group: 'Umiestnenie' },
        { value: 'room', label: 'Miestnosť', group: 'Umiestnenie' },
        { value: 'internalPossessionsNumber', label: 'Interné č. majetku', group: 'Doplňujúce info' },
        { value: 'internalNote', label: 'Interná poznámka', group: 'Doplňujúce info' },
        { value: 'department', label: departmentText('Položka úrovne', 'Stredisko'), group: 'Väzby' },
        { value: 'deviceSubtypeId', label: 'Typ zariadenia', group: 'Väzby' },
        { value: EVIDENCE_FIELD_DEVICE_PROPERTIES[0], label: 'Evidenčné pole', group: 'Väzby' },
        { value: EVIDENCE_FIELD_DEVICE_PROPERTIES[1], label: 'Evidenčné pole (neprepísať)', group: 'Väzby' },
      ] satisfies SelectItem[],
    [departmentText]
  );

  return <Select data={properties} {...props} />;
}
